export default function PricingSection() {
  return (
    <section className="pricing-section" id="pricing">
      <div className="container">
        <div className="section-header">
          <span className="section-label gold">Transparentní ceník</span>
          <h2>Platíte jen za to, co skutečně přenesete</h2>
          <p>Žádné měsíční paušály za nevyužité funkce. Žádné skryté poplatky.</p>
        </div>
        <div className="pricing-grid">
          <div className="pricing-card">
            <div className="pricing-card-name">Platební brány</div>
            <div className="pricing-card-desc">Stripe, PayPal, Comgate, Cardinity, Shoptet Pay, Pays</div>
            <div className="pricing-card-price"><span className="price">300 Kč</span><span className="unit"> / měsíc</span><div className="note">Flat fee. Neomezený počet transakcí.</div></div>
            <ul className="pricing-features">
              <li><span className="check">&#10003;</span> Všechny platební brány v jednom</li>
              <li><span className="check">&#10003;</span> Automatické párování plateb</li>
              <li><span className="check">&#10003;</span> Správné předkontace</li>
              <li><span className="check">&#10003;</span> Bez limitu na transakce</li>
            </ul>
            <a href="#cta" className="pricing-btn pricing-btn-secondary">Chci vědět víc</a>
          </div>

          <div className="pricing-card featured">
            <div className="pricing-card-name">Ostatní systémy</div>
            <div className="pricing-card-desc">E-shopy, hotely, dopravci, fakturace, CSV/XML import</div>
            <div className="pricing-card-price"><span className="price">2–4 Kč</span><span className="unit"> / doklad</span><div className="note">Degresivní cena. Čím víc, tím levněji.</div></div>
            <ul className="pricing-features">
              <li><span className="check">&#10003;</span> 1–100 dokladů: 4,0 Kč</li>
              <li><span className="check">&#10003;</span> 101–500: 3,5 Kč</li>
              <li><span className="check">&#10003;</span> 501–1 000: 3,0 Kč</li>
              <li><span className="check">&#10003;</span> 1 001–5 000: 2,5 Kč</li>
              <li><span className="check">&#10003;</span> 5 001+: 2,0 Kč</li>
              <li><span className="check">&#10003;</span> 10% sleva při předplacení</li>
            </ul>
            <a href="#cta" className="pricing-btn pricing-btn-primary">Spočítejte mi to</a>
          </div>

          <div className="pricing-card">
            <div className="pricing-card-name">Implementace</div>
            <div className="pricing-card-desc">Jednorázové nastavení — my uděláme vše za vás</div>
            <div className="pricing-card-price"><span className="price">2 000 Kč</span><span className="unit"> jednorázově</span><div className="note">Za účetní jednotku. All-in-one.</div></div>
            <ul className="pricing-features">
              <li><span className="check">&#10003;</span> Kompletní konfigurace</li>
              <li><span className="check">&#10003;</span> Mapování dokladů</li>
              <li><span className="check">&#10003;</span> Napojení na Money S3</li>
              <li><span className="check">&#10003;</span> Zaškolení</li>
              <li><span className="check">&#10003;</span> Test na reálných datech</li>
            </ul>
            <a href="#cta" className="pricing-btn pricing-btn-secondary">Objednat implementaci</a>
          </div>
        </div>
      </div>
    </section>
  );
}
